import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Products.css';

import iotPlcImage from '../assets/iot_plc_controller.png';
import smartSensorImage from '../assets/smart_sensor_icons.png';
import edgeAiImage from '../assets/edge_ai_module.png';

const Products = () => {
    const products = [
        {
            id: 1,
            name: 'IoT PLC 컨트롤러',
            image: iotPlcImage,
            features: ['MQTT 지원', 'Wi-Fi 및 BLE', '원격 제어'],
            description: '스마트 팩토리 자동화를 위한 산업 등급 IoT PLC.'
        },
        {
            id: 2,
            name: '스마트 환경 센서',
            image: smartSensorImage,
            features: ['온도/습도', '공기 질', '데이터 로깅'],
            description: '환경 모니터링을 위한 고정밀 센서.'
        },
        {
            id: 3,
            name: '엣지 AI 모듈',
            image: edgeAiImage,
            features: ['NPU 내장', 'TensorFlow Lite', '비전 AI'],
            description: '디바이스 내 AI를 위한 강력한 엣지 컴퓨팅 모듈.'
        }
    ];

    return (
        <div className="section products-section" id="products">
            <div className="container">
                <h2 className="section-title">우리 제품</h2>
                <div className="products-grid">
                    {products.map((product) => (
                        <div className="product-card" key={product.id}>
                            <div className="product-image">
                                <img src={product.image} alt={product.name} />
                            </div>
                            <div className="product-info">
                                <h3 className="product-name">{product.name}</h3>
                                <p className="product-desc">{product.description}</p>
                                <ul className="product-features">
                                    {product.features.map((feature, idx) => (
                                        <li key={idx}>
                                            <i className="fas fa-check"></i> {feature}
                                        </li>
                                    ))}
                                </ul>
                                <Link to="/products" className="btn btn-primary product-btn">자세히 보기</Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Products;

